import { actionize, apiAction, apiFetch } from 'utils';
import DuckEntity from './DuckEntity';

const apiCredentialsDuck = new DuckEntity('apiCredentials');

const generateJwtTypes = actionize({
  GENERATE_JWT_BEGIN: null,
  GENERATE_JWT_SUCCESS: null,
  GENERATE_JWT_ERROR: null
}, action => `schooladmin/actions/${action}`);

const generateJwt = (credentialId) => apiAction(
  generateJwtTypes.GENERATE_JWT_BEGIN,
  generateJwtTypes.GENERATE_JWT_SUCCESS,
  generateJwtTypes.GENERATE_JWT_ERROR,
  state => apiFetch.post(state, `${apiCredentialsDuck.config.entityApiPath(credentialId)}/generate_jwt`, {})
);

const regenerateTypes = actionize({
  REGENERATE_SECRET_BEGIN: null,
  REGENERATE_SECRET_SUCCESS: null,
  REGENERATE_SECRET_ERROR: null
}, action => `schooladmin/actions/${action}`);

const regenerateSecret = (credentialId) => apiAction(
  regenerateTypes.REGENERATE_SECRET_BEGIN,
  regenerateTypes.REGENERATE_SECRET_SUCCESS,
  regenerateTypes.REGENERATE_SECRET_ERROR,
  state => apiFetch.post(state, `${apiCredentialsDuck.config.entityApiPath(credentialId)}/regenerate_secret`, {}),
  {
    id: credentialId,
    entityName: apiCredentialsDuck.config.name
  },
  { [apiCredentialsDuck.config.jsonRoot]: apiCredentialsDuck.config.schema }
);

export default apiCredentialsDuck.reducer;
export const entity = {
  ...apiCredentialsDuck,
  actions: {
    ...apiCredentialsDuck.actions,
    generateJwt,
    regenerateSecret
  }
};
